/**
 * 不带全局鉴权拦截器的 Axios 实例，仅用于 refresh 等必须避免「401→再 refresh」死循环的请求。
 */
import axios from 'axios'

function isApiBusinessSuccess(code) {
  const n = typeof code === 'string' ? Number(String(code).trim()) : Number(code)
  return !Number.isNaN(n) && n === 200
}

function isUnifiedApiEnvelope(body) {
  return (
    body !== null &&
    typeof body === 'object' &&
    !Array.isArray(body) &&
    Object.prototype.hasOwnProperty.call(body, 'code')
  )
}

export const httpBare = axios.create({
  withCredentials: true,
  timeout: 30000
})

httpBare.interceptors.response.use(
  (response) => {
    const body = response.data
    if (!isUnifiedApiEnvelope(body)) {
      return response
    }
    if (isApiBusinessSuccess(body.code)) {
      return { ...response, data: body.data }
    }
    const msg =
      body.msg != null && String(body.msg).trim() !== ''
        ? String(body.msg)
        : '请求失败'
    const err = new Error(msg)
    err.response = response
    err.isApiBusinessError = true
    return Promise.reject(err)
  },
  (err) => Promise.reject(err)
)
